// extracted by mini-css-extract-plugin
export default {"login-page":"LoginPage_login-page__kJ2g9","form":"LoginPage_form__ActSp","logo":"LoginPage_logo__jru4J"};